import { isEmpty, not } from 'ramda'

import { FlexGrid, Typography, Box, StackView, Spacer } from '@telus-uds/components-web'
import { components, utils } from '@digital-commerce/shared-utils'

import { getCartType } from '../../../utils/cart'
import { StyledGrid, StyledColumn } from './styles/styles'
import useValueProps from '../../../hooks/useValueProps'

import ValuePropsItem from './ValuePropsItem'
import useTranslate from '../../../hooks/useTranslate'
import useCart from '../../../hooks/useCart'

const { ShouldRender } = components
const { getCustomerType } = utils.customer

const ValueProps = () => {
  const { cart } = useCart()
  const translate = useTranslate()

  const cartType = getCartType(cart)
  const customerType = getCustomerType(cart?.root?.customer)
  const { data: valuePropsContent } = useValueProps({ customerType, cartType })

  if (!valuePropsContent) return null

  const valuePropsHeading = translate('valueProps.heading', true)

  const shouldShowValueProps = () => not(isEmpty(valuePropsContent.items))

  return (
    <Box>
      <ShouldRender when={shouldShowValueProps()}>
        {() => (
          <StackView testID="value-props-container" data-test-animation="true">
            <Spacer space={7} />
            <StyledGrid>
              <FlexGrid.Row>
                <Typography testID="heading" variant={{ size: 'h2' }}>
                  {valuePropsHeading}
                </Typography>
              </FlexGrid.Row>
              <Spacer space={{ xs: 3, md: 4 }} />
              <StackView
                direction={{ xs: 'column', md: 'row' }}
                space={3}
                tokens={{
                  alignItems: 'start'
                }}
              >
                {valuePropsContent.items.map((content) => (
                  <StyledColumn key={content.sys.id} testID="value-props-item">
                    <ValuePropsItem content={content} />
                  </StyledColumn>
                ))}
              </StackView>
            </StyledGrid>
            <Spacer space={7} />
          </StackView>
        )}
      </ShouldRender>
    </Box>
  )
}

export default ValueProps
